<template>
  <form ref="registerForm" @submit.prevent="submit" autocomplete="off">
    <div class="register-content">
      <div class="py-3">
        <h3 class="font-weight-bold fc-dark-blue">
          กรอกข้อมูลและอัปโหลดเอกสาร
        </h3>
        <p>กรุณากรอกข้อมูลของท่านให้ถูกต้องและครบถ้วน เพื่อใช้ในการลงทะเบียน</p>
        <div class="d-flex align-items-center" style="gap: 10px;">
          <div>
            <h6 class="font-weight-bold m-0 fc-dark-blue">ตำแหน่งที่สมัคร:</h6>
          </div>
          <div>
            <select class="form-control" v-model="accountInfo.position">
              <option value="DATA_TAGGING" selected>Data Tagging</option>
            </select>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header"><h5>ข้อมูลส่วนตัว</h5></div>
        <div class="card-body">
          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.firstname_th.$invalid &&
                  $v.accountInfo.firstname_th.$dirty
              }"
            >
              <label for="firstname_th"
                >ชื่อ (ไทย) <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="firstname_th"
                v-model.trim="accountInfo.firstname_th"
              />
            </div>

            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.lastname_th.$invalid &&
                  $v.accountInfo.lastname_th.$dirty
              }"
            >
              <label for="lastname_th"
                >นามสกุล (ไทย) <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="lastname_th"
                v-model.trim="accountInfo.lastname_th"
              />
            </div>
          </div>

          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.firstname_en.$invalid &&
                  $v.accountInfo.firstname_en.$dirty
              }"
            >
              <label for="firstname_en"
                >ชื่อ (อังกฤษ) <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="firstname_en"
                v-model.trim="accountInfo.firstname_en"
              />
            </div>

            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.lastname_en.$invalid &&
                  $v.accountInfo.lastname_en.$dirty
              }"
            >
              <label for="lastname_en"
                >นามสกุล (อังกฤษ) <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="lastname_en"
                v-model.trim="accountInfo.lastname_en"
              />
            </div>
          </div>

          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.phone.$invalid && $v.accountInfo.phone.$dirty
              }"
            >
              <label for="phone"
                >เบอร์โทรศัพท์ <span class="text-danger">*</span></label
              >
              <the-mask
                :mask="['###-#######']"
                type="tel"
                class="form-control"
                id="phone"
                v-model.trim="accountInfo.phone"
              />
            </div>

            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.email.$invalid && $v.accountInfo.email.$dirty
              }"
            >
              <label for="email"
                >Email <span class="text-danger">*</span></label
              >
              <input
                type="email"
                class="form-control"
                id="email"
                v-model.trim="accountInfo.email"
              />
            </div>
          </div>

          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.birth_date.$invalid &&
                  $v.accountInfo.birth_date.$dirty
              }"
            >
              <label for="birth_date"
                >วัน/เดือน/ปีเกิด (ค.ศ.)<span class="text-danger"
                  >*</span
                ></label
              >
              <div>
                <date-picker
                  inputClass="form-control"
                  class="w-100"
                  placeholder="DD/MM/YYYY"
                  v-model="accountInfo.birth_date"
                  value-type="YYYY-MM-DD"
                  format="DD/MM/YYYY"
                ></date-picker>
              </div>
            </div>

            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.id_card.$invalid &&
                  $v.accountInfo.id_card.$dirty
              }"
            >
              <label for="id_card"
                >เลขประจำตัวประชาชน <span class="text-danger">*</span></label
              >
              <the-mask
                :mask="['#-####-#####-##-#']"
                type="text"
                class="form-control"
                id="id_card"
                v-model.trim="accountInfo.id_card"
              />
            </div>
          </div>

          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.bank.$invalid && $v.accountInfo.bank.$dirty
              }"
            >
              <label for="bank"
                >ธนาคาร <span class="text-danger">*</span></label
              >
              <select
                class="form-control"
                id="bank"
                v-model.trim="accountInfo.bank"
              >
                <option value="" disabled>เลือกธนาคาร</option>
                <option value="ธนาคารกรุงเทพ">ธนาคารกรุงเทพ</option>
                <option value="ธนาคารกรุงไทย">ธนาคารกรุงไทย</option>
                <option value="ธนาคารกรุงศรีอยุธยา">ธนาคารกรุงศรีอยุธยา</option>
                <option value="ธนาคารกสิกรไทย">ธนาคารกสิกรไทย</option>
                <option value="ธนาคารเกียรตินาคินภัทร"
                  >ธนาคารเกียรตินาคินภัทร</option
                >
                <option value="ธนาคารซีไอเอ็มบี ไทย"
                  >ธนาคารซีไอเอ็มบี ไทย</option
                >
                <option value="ธนาคารทหารไทยธนชาต">ธนาคารทหารไทยธนชาต</option>

                <option value="ธนาคารทิสโก้">ธนาคารทิสโก้</option>
                <option value="ธนาคารไทยพาณิชย์">ธนาคารไทยพาณิชย์</option>
                <option value="ธนาคารยูโอบี">ธนาคารยูโอบี</option>
                <option value="ธนาคารแลนด์ แอนด์ เฮ้าส์"
                  >ธนาคารแลนด์ แอนด์ เฮ้าส์</option
                >
                <option value="ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)"
                  >ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)</option
                >
                <option value="ธนาคารไอซีบีซี (ไทย)"
                  >ธนาคารไอซีบีซี (ไทย)</option
                >
              </select>
            </div>

            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.bank_account.$invalid &&
                  $v.accountInfo.bank_account.$dirty
              }"
            >
              <label for="bank_account"
                >เลขที่บัญชีธนาคาร <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="bank_account"
                v-model.trim="accountInfo.bank_account"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h5>ข้อมูลที่อยู่ (ใช้ในการจัดส่งเอกสาร)</h5>
        </div>
        <div class="card-body">
          <div class="row form-group">
            <div
              class="col-12"
              :class="{
                error:
                  $v.accountInfo.document_address.$invalid &&
                  $v.accountInfo.document_address.$dirty
              }"
            >
              <label for="document_address"
                >ที่อยู่ <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="document_address"
                v-model.trim="accountInfo.document_address"
              />
            </div>
          </div>

          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.document_district.$invalid &&
                  $v.accountInfo.document_district.$dirty
              }"
            >
              <label for="document_district"
                >แขวง/ตำบล <span class="text-danger">*</span></label
              >
              <sub-district-input
                type="text"
                label=""
                inputClass="form-control"
                id="document_district"
                v-model.trim="accountInfo.document_district"
              />
            </div>

            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.document_subdistrict.$invalid &&
                  $v.accountInfo.document_subdistrict.$dirty
              }"
            >
              <label for="document_subdistrict"
                >เขต/อำเภอ <span class="text-danger">*</span></label
              >
              <district-input
                type="text"
                label=""
                inputClass="form-control"
                id="document_subdistrict"
                v-model.trim="accountInfo.document_subdistrict"
              />
            </div>
          </div>

          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.document_province.$invalid &&
                  $v.accountInfo.document_province.$dirty
              }"
            >
              <label for="document_province"
                >จังหวัด <span class="text-danger">*</span></label
              >
              <province-input
                type="text"
                label=""
                inputClass="form-control"
                id="document_province"
                v-model.trim="accountInfo.document_province"
              />
            </div>

            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.document_postcode.$invalid &&
                  $v.accountInfo.document_postcode.$dirty
              }"
            >
              <label for="document_postcode"
                >รหัสไปรษณีย์ <span class="text-danger">*</span></label
              >
              <zip-code-input
                type="text"
                label=""
                inputClass="form-control"
                id="document_postcode"
                v-model.trim="accountInfo.document_postcode"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <label>ลักษณะที่อยู่อาศัย</label>
              <div class="form-group d-flex">
                <label class="radio-inline mr-2 d-flex">
                  <input
                    type="radio"
                    class="styled control-primary"
                    name="live_with"
                    v-model.trim="accountInfo.live_with"
                    value="อาศัยกับครอบครัว"
                  />
                  อาศัยกับครอบครัว
                </label>
                <label class="radio-inline mr-2 d-flex">
                  <input
                    type="radio"
                    class="styled control-primary"
                    name="live_with"
                    v-model.trim="accountInfo.live_with"
                    value="บ้านตัวเอง"
                  />
                  บ้านตัวเอง</label
                >
                <label class="radio-inline d-flex">
                  <input
                    type="radio"
                    class="styled control-primary"
                    name="live_with"
                    v-model.trim="accountInfo.live_with"
                    value="บ้านเช่า/หอพัก"
                  />
                  บ้านเช่า/หอพัก</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h5>เอกสารแนบ</h5>
        </div>
        <div class="card-body">
          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.document_book_bank.$invalid &&
                  $v.accountInfo.document_book_bank.$dirty
              }"
            >
              <label for="book_bank_file"
                >หน้าสมุดบัญชีธนาคาร <span class="text-danger">*</span></label
              >
              <div class="uniform-uploader">
                <input
                  ref="book_bank_filename"
                  @change="
                    showFileName('book_bank_filename', 'document_book_bank')
                  "
                  type="file"
                  class="form-control-uniform"
                  data-fouc=""
                  id="book_bank_file"
                  accept="image/*,application/pdf"
                /><span
                  class="filename"
                  id="book_bank_filename"
                  style="user-select: none;"
                  >No file selected</span
                ><span class="action btn btn-light" style="user-select: none;"
                  >เลือกไฟล์</span
                >
              </div>
              <div>
                <small class="text-muted"
                  >สามารถแนบไฟล์ขนาดสูงสุด : 5MB ,เป็นไฟล์ รูปภาพและ .pdf เท่านั้น</small
                >
              </div>
            </div>
          </div>

          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.document_id_card.$invalid &&
                  $v.accountInfo.document_id_card.$dirty
              }"
            >
              <label for="id_card_file"
                >สำเนาบัตรประชาชน <span class="text-danger">*</span></label
              >
              <div class="uniform-uploader">
                <input
                  ref="id_card_filename"
                  @change="showFileName('id_card_filename', 'document_id_card')"
                  type="file"
                  class="form-control-uniform"
                  data-fouc=""
                  id="id_card_file"
                  accept="image/*,application/pdf"
                /><span
                  class="filename"
                  id="id_card_filename"
                  style="user-select: none;"
                  >No file selected</span
                ><span class="action btn btn-light" style="user-select: none;"
                  >เลือกไฟล์</span
                >
              </div>
              <div>
                <small class="text-muted"
                  >สามารถแนบไฟล์ขนาดสูงสุด : 5MB ,เป็นไฟล์ รูปภาพและ .pdf เท่านั้น</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h5>บุคคลอ้างอิง</h5>
        </div>
        <div class="card-body">
          <div class="row form-group">
            <div
              class="col-12 col-md-5"
              :class="{
                error:
                  $v.accountInfo.referal_firstname_th.$invalid &&
                  $v.accountInfo.referal_firstname_th.$dirty
              }"
            >
              <label for="referal_firstname_th"
                >ชื่อ (ไทย) <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="referal_firstname_th"
                v-model.trim="accountInfo.referal_firstname_th"
              />
            </div>

            <div
              class="col-12 col-md-5"
              :class="{
                error:
                  $v.accountInfo.referal_lastname_th.$invalid &&
                  $v.accountInfo.referal_lastname_th.$dirty
              }"
            >
              <label for="referal_lastname_th"
                >นามสกุล (ไทย) <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="referal_lastname_th"
                v-model.trim="accountInfo.referal_lastname_th"
              />
            </div>

            <div
              class="col-12 col-md-2"
              :class="{
                error:
                  $v.accountInfo.referal_relation.$invalid &&
                  $v.accountInfo.referal_relation.$dirty
              }"
            >
              <label for="referal_relation"
                >ความสัมพันธ์ <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="referal_relation"
                v-model.trim="accountInfo.referal_relation"
              />
            </div>
          </div>

          <div class="row form-group">
            <div
              class="col-12 col-md-6"
              :class="{
                error:
                  $v.accountInfo.referal_phone.$invalid &&
                  $v.accountInfo.referal_phone.$dirty
              }"
            >
              <label for="referal_phone"
                >เบอร์โทรศัพท์ <span class="text-danger">*</span></label
              >
              <the-mask
                :mask="['###-#######']"
                type="tel"
                class="form-control"
                id="referal_phone"
                v-model.trim="accountInfo.referal_phone"
              />
            </div>

            <div class="col-12 col-md-6">
              <label for="referal_email">Email </label>
              <input
                type="email"
                class="form-control"
                id="referal_email"
                v-model.trim="accountInfo.referal_email"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="pb-3">
        <label for="">
          <div
            class="custom-control custom-checkbox custom-control-inline"
            v-b-modal.consent
          >
            <input
              type="checkbox"
              class="custom-control-input"
              id="custom_checkbox_inline_unchecked"
              v-model="accountInfo.accept"
            />
            <div
              class="custom-control-label"
              for="custom_checkbox_inline_unchecked"
            >
              ข้าพเจ้าให้ความยินยอมแก่ บริษัท อินไซท์เอรา จำกัด ในการเก็บ และใช้
              <a href="#" @click.prevent="">ข้อมูลส่วนบุคคล</a> ของข้าพเจ้า
              เพื่อติดต่อกลับข้าพเจ้า หรือ ส่งต่อไปยังผู้เกี่ยวข้อง
              เพื่อดำเนินการตามวัตถุประสงค์
            </div>
          </div>
        </label>
      </div>

      <div class="text-center">
        <button class="btn btn-primary" type="submit" :disabled="isSubmitting">
          <i class="icon-spinner9 spinner mr-2" v-if="isSubmitting"></i>
          <i class="far fa-paper-plane mr-2" v-else></i>
          Submit Form
        </button>
      </div>
    </div>

    <b-modal
      id="consent"
      title="การยินยอมให้เก็บข้อมูลส่วนบุคคล"
      ok-title="Accept"
      cancel-title="Reject"
      cancel-variant="danger"
      ok-variant="success"
      @ok="accountInfo.accept = true"
      @cancel="accountInfo.accept = false"
    >
      <div v-html="consent"></div>
    </b-modal>
  </form>
</template>

<script>
import {
  DistrictInput,
  ProvinceInput,
  ZipCodeInput,
  SubDistrictInput
} from 'vue-thailand-address'
import { BModal, VBModal } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { TheMask } from 'vue-the-mask'
import serviceRoutes from '../../service-routes'
export default {
  mixins: [validationMixin],
  components: {
    'b-modal': BModal,
    DistrictInput,
    ProvinceInput,
    ZipCodeInput,
    SubDistrictInput,
    TheMask
  },
  directives: {
    'b-modal': VBModal
  },
  validations: {
    accountInfo: {
      firstname_th: { required },
      lastname_th: { required },
      firstname_en: { required },
      lastname_en: { required },
      position: { required },
      birth_date: { required },
      bank: { required },
      bank_account: { required },
      id_card: { required },
      phone: { required },
      email: { required, email },

      document_book_bank: { required },
      document_id_card: { required },

      document_address: { required },
      document_district: { required },
      document_subdistrict: { required },
      document_province: { required },
      document_postcode: { required },

      live_with: { required },

      referal_firstname_th: { required },
      referal_lastname_th: { required },
      referal_relation: { required },
      referal_phone: { required }
    }
  },
  data () {
    return {
      isSubmitting: false,
      consent: '',
      accountInfo: {
        firstname_th: '',
        lastname_th: '',
        firstname_en: '',
        lastname_en: '',
        position: 'DATA_TAGGING',
        birth_date: '',
        document_book_bank: null,
        document_id_card: null,
        bank: '',
        bank_account: '',
        id_card: '',

        phone: '',
        email: '',

        document_address: '',
        document_district: '',
        document_subdistrict: '',
        document_province: '',
        document_postcode: '',

        live_with: 'อาศัยกับครอบครัว',

        referal_firstname_th: '',
        referal_lastname_th: '',
        referal_relation: '',
        referal_phone: '',
        referal_email: '',
        accept: false
      }
    }
  },
  mounted () {
    setTimeout(() => {
      window.$('.control-primary').uniform({
        wrapperClass: 'mr-2'
      })
    }, 0)
    this.getConsent().then(content => {
      this.consent = content
    })
  },
  methods: {
    showFileName (field, dataField) {
      let allowTypes = ['image/', 'application/pdf']
      let file = this.$refs[field].files[0]

      let validType = allowTypes.filter(v => file.type.startsWith(v)).length
      if (!validType || file.size > 5 * 10e5) {
        this.accountInfo[dataField] = null
      } else {
        this.accountInfo[dataField] = file
      }

      document.getElementById(field).innerHTML = this.accountInfo[dataField]
        ? this.accountInfo[dataField].name
        : 'No file selected'
    },
    async getConsent () {
      let res = await serviceRoutes.getRegisterConsent()
      let content = res.data.data.content
      return content
    },
    submit () {
      if (this.isSubmitting) return

      this.$v.$touch()
      if (!this.$v.$invalid) {
        const formData = new FormData()
        for (let key in this.accountInfo) {
          formData.append(key, this.accountInfo[key])
        }
        this.isSubmitting = true
        serviceRoutes
          .register(formData)
          .then(res => {
            let user = res.data.data
            this.$emit('success', user)
          })
          .catch((res) => {
            alert(`Register error: ${res.data.message}, please contact admin`)
          })
          .finally(() => {
            this.isSubmitting = false
          })
      }
    }
  }
}
</script>

<style scoped>
.card-header:after {
content: '';
border: 1px solid #dddddd;
position: absolute;
border-top: none;
border-left: none;
border-right: none;
width: 95%;
}

.card-header {
color: #141b4d;
}

p {
  font-size: 16px;
}
.register-content {
  padding: 0 10rem;
  padding-bottom: 5rem;
  background-color: #f9fafe;
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #25b372;
}

.fw-500 {
  font-weight: 500;
}

.card > .card-header > h5 {
  font-weight: 500 !important;
  font-size: 16px !important;
}

.col-12.error:after {
  content: 'โปรดระบุ';
  color: red;
}
</style>

<style>
.th-address-autocomplete {
  background-color: white !important;
}
</style>
